module.exports = gl_rr;